import { locationIdFormat } from "@redotech/redo-ids-cockroach";
import { RedoFulfillmentToteSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote";
import * as z from "zod";

export const getToteByBarcode = {
  name: "getToteByBarcode" as const,
  input: z.object({
    barcode: z.string().max(255),
    locationId: locationIdFormat.schema.nullish(),
  }),
  output: RedoFulfillmentToteSchema,
};

export type GetToteByBarcodeInput = z.infer<typeof getToteByBarcode.input>;
